import { createInstance } from './sdkLoader';
import { SHARETRIBE_PUBLIC_CLIENT_ID } from '../config/env';

// Lazily create Web SDK to avoid SSR import-time failures
let sdk;
const getSdk = () => {
  if (!sdk) {
    const clientId = SHARETRIBE_PUBLIC_CLIENT_ID || process.env.REACT_APP_SHARETRIBE_CLIENT_ID;
    sdk = createInstance({ clientId });
  }
  return sdk;
};

export const runUserTransition = (txId, transition, params = {}) =>
  getSdk().transactions.transition({ id: txId, transition, params });
